/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import styled from 'styled-components';
import Icon from '@omilia/icon';

import ReactSimpleDropdown, {
  DropdownTrigger,
  DropdownContent,
} from 'react-simple-dropdown';

import { sortOptionType } from 'types';
import useTheme from 'theme/useTheme';
import SortingMenuItem from './SortingMenuItem';

import './style.scss';

const StyledIcon = styled(Icon)`
  margin-right: 0.5rem;
`;

const ThemedIcon = props => {
  const { colors } = useTheme();

  return <StyledIcon {...props} primaryColor={colors.manateeGrey} />;
};

export default class SortingMenu extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    options: PropTypes.arrayOf(sortOptionType).isRequired,
    selectedSortOption: sortOptionType.isRequired,
    className: PropTypes.string,
    getItems: PropTypes.func,
  };

  shouldComponentUpdate(nextProps) {
    return (
      !_isEqual(nextProps.selectedSortOption, this.props.selectedSortOption) ||
      !_isEqual(nextProps.items, this.props.items)
    );
  }

  handleClick = item => {
    this.props.getItems({
      page: 1,
      ordering: item.value,
    });

    this.dropdown.hide();
  };

  hasItems = () => this.props.items?.length > 0;

  render() {
    const { className, options, selectedSortOption } = this.props;

    return (
      <ReactSimpleDropdown
        ref={el => {
          this.dropdown = el;
        }}
        className={className}
        disabled={!this.hasItems()}
        styleName="sorting-menu"
      >
        <DropdownTrigger
          data-test="trigger-sorting-menu"
          disabled={!this.hasItems()}
        >
          <ThemedIcon glyph="sorting" size="14" />
          {selectedSortOption.label}
        </DropdownTrigger>

        <DropdownContent>
          <div styleName="title">Sort by:</div>

          {options.map(item => (
            <SortingMenuItem
              key={item.value}
              handleClick={this.handleClick}
              isActive={selectedSortOption.label === item.label}
              item={item}
            >
              {item.label}
            </SortingMenuItem>
          ))}
        </DropdownContent>
      </ReactSimpleDropdown>
    );
  }
}
